import React, { useContext, ReactNode } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Social from './Social';
import ShortFormVideo from './ShortFormVideo';

import { socialSubTopics } from 'topics';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import { EntityContext } from 'context/entityContext';

const SocialParent: React.FC<any> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="social" variants={socialSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />
      <Switch>
        <Route
          exact
          path={`${pathPrefix}/artist/${entityId}/social/engagement`}
          render={(): ReactNode => <Social />}
        />
        <Route
          exact
          path={`${pathPrefix}/artist/${entityId}/social/shortFormVideo`}
          render={(): ReactNode => <ShortFormVideo />}
        />
        <Redirect
          exact
          path={`${pathPrefix}/artist/${entityId}/social/linkfire`}
          to={`${pathPrefix}/artist/${entityId}/social/engagement`}
        />
      </Switch>
    </>
  );
};

export default SocialParent;
